// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"c9ba0921","182":"91395530","484":"38d48ca7","508":"9c5afc2f","551":"66dca899","559":"b6ee7d14","833":"89ca3d7f"}[chunkId] + ".chunk.js";
};